import {
    GetChatList,
    GetChatMessage,
    GetChatHistory,
    GetChatMessageHistory
} from '../constants';
import { fromJS } from 'immutable';

const initialState = {  
    chatdetail:fromJS([]),
    queues: fromJS([]),
    tickets: fromJS([]),
    messages: fromJS({}),
    history: fromJS({}),
    historymessages : fromJS({}),
    isLoading: false,
};

export default (state, action) => {
    state = state || initialState;

    if (action.type === GetChatList) {
        return {
            ...state,
            queues: action.queues,
            tickets: action.newticket
        };
    }

    if (action.type === GetChatMessage) {
        return {
            ...state,
            messages: action.chat,
            chatdetail:action.detail
        };
    }

    if (action.type === GetChatHistory) {
        return {
            ...state,
            history: action.data
        };
    }

    if (action.type === GetChatMessageHistory) {
        return {
            ...state,
            historymessages: action.chat
        };
    }

    return state;
};
